module.exports = __webpack_public_path__ + "img/Background4.1f730583.png";